import { createStyles, makeStyles } from '@material-ui/core'

export const useReviewItemStyles = makeStyles((theme) =>
  createStyles({
    root: {
      paddingBottom: 19,
      '&:not(:last-child)': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
      },
      '&:not(:first-child)': {
        paddingTop: 11
      }
    },

    reviewTop: {
      display: 'flex',
      justifyContent: 'space-between'
    },

    reviewTopLeft: {
      display: 'flex',
      gap: 16
    },

    reviewAuthorAvatar: {
      width: 32,
      height: 32,
      borderRadius: '50%'
    },

    reviewAuthorName: {
      fontWeight: 500,
      [theme.breakpoints.down('xs')]: {
        maxWidth: 150
      }
    },

    reviewEstimate: {},

    reviewTopRight: {},

    reviewDate: {},

    reviewBody: {
      paddingLeft: 48
    },

    reviewText: {},

    reviewImagesPreviews: {
      marginTop: 7,
      display: 'flex',
      gap: 7
    },

    reviewBox: {
      cursor: 'pointer',
      transition: '0.4s',

      '&:hover': {
        transform: 'scale(1.2)'
      }
    },

    reviewImagePreview: {},

    lowScore: {
      color: '#E52428'
    },

    mediumScore: {
      color: '#FFBE2B'
    },

    highScore: {
      color: '#24C034'
    },

    modalImage: {
      position: 'relative',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 900,
      height: 600,
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0)',
      boxShadow: 'none',
      [theme.breakpoints.down(960)]: {
        width: 600,
        height: 400
      },
      [theme.breakpoints.down(600)]: {
        width: '100%',
        height: '100%'
      }
    },

    closeBtn: {
      position: 'absolute',
      top: '-5%',
      left: '100%',
      cursor: 'pointer',
      [theme.breakpoints.down(960)]: {
        top: '-5%',
        left: '90%'
      },
      [theme.breakpoints.down(600)]: {
        left: '93%',
        top: '25%',
        transform: 'translateX(-50%)'
      }
    },

    image: {
      width: '80%',
      height: '100%',
      border: 'none',
      flex: 1
    }
  })
)
